// removed by extract-text-webpack-plugin
module.exports = {"basic":"basic-1Fg9r","xs":"xs-2khqA","sm":"sm-2wjBM","md":"md-36P-q","lg":"lg-OOXp0","confirm":"confirm-2Mb8u basic-1Fg9r","header":"header-Se4ds","close":"close-2mrkh"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/modals/styles.scss
 ** module id = 30
 ** module chunks = 0
 **/